<app-titlebar #titlebar>
</app-titlebar>

<mat-tab-group #masterTabGroup class="jk-tab-group" (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="條件設定">
    <mat-toolbar class="h-9">
      <button mat-flat-button class="btn" [class.btn-primary]="true" (click)="doQuery()">
        <mat-icon fontIcon="search"></mat-icon>查詢
      </button>
      <button mat-flat-button class="btn" [class.btn-primary]="true" (click)="doGetPreFilter()">
        <mat-icon fontIcon="search"></mat-icon>取前次
      </button>
    </mat-toolbar>
    <div class="flex">
      <div style="width: 400px;">
        <app-jkcombobox label="方式" [(value)]="kind" [items]="kindList">
        </app-jkcombobox>

      </div>
      <div style="width: 400px;">
        @if(kind === '1'){
        <app-jkcombobox #stklg002Com label="資料頻率" [(value)]="stockSrv.stklg002" [items]="stklg002List">
        </app-jkcombobox>
        }

      </div>
    </div>
    @if(kind === '1' || kind === '3'){
    <app-jkdaterange #stklg001Com label="交易日期" [(valueA)]="stockSrv.date1" [(valueB)]="stockSrv.date2">
      [showClearButton]="true"
    </app-jkdaterange>
    }
    <!-- 1:明細 2:日線未產生 3:日線統計 -->
    @if(kind === '2'){
    <app-jkdatefield label="交易日期" [(value)]="stockSrv.date1">
      [showClearButton]="true"
    </app-jkdatefield>
    }
    @if(kind === '1' ){
    <div class="flex">
      <app-jkbtnedit #stklg004 label="股票代號" [required]="false" [value]="stockNo" maintable="STKMA" item="W01"
        [showClearButton]="true">
      </app-jkbtnedit>
      <app-jkrange #stklg004r class="jk-range" label="股票代號" [required]="false" maintable="STKMA" [item]="'W01'"
        [valueA]="stockNo1" [showOpenWinButton]="true" [valueB]="stockNo2">
      </app-jkrange>
      <app-jkmultiselect #stklg004m maintable="STKMA" item="W01" label="股票代號" valueExpr="MA001" displayExpr="MA002"
        [(values)]="stockNoList">
      </app-jkmultiselect>
    </div>
    }
    @if(kind === '1'){
    <div class="flex">
      <app-jkcombobox #stkma019 label="商品種類"  [(value)]="marketNo" [canSpace]="true" [items]="stkma019List"
        [showClearButton]="true">
      </app-jkcombobox>
      <app-jkcombobox #orderby label="排序方式" [(value)]="order" [items]="orderList">
      </app-jkcombobox>
    </div>
    }
  </mat-tab>
  <mat-tab #myTabDetail label="詳細資料">
    <!-- (rowClicked)="gridMain.agRowClicked($event)"
    (rowSelected)="gridMain.agRowSelected($event)" class="jk-h-full-200" -->
    <div>
      <app-jkgridwin #jkgridwin (afterGridReady)="afterGridReady($event)"></app-jkgridwin>
    </div>
  </mat-tab>
</mat-tab-group>
